import {Component} from "react";
import {Button, Drawer, message, Table} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {WindowParamContext} from "../../../../../library/context/WindowContext";
import {
    addOrUpdateExchangeCode,
    AddOrUpdateExchangeCodeReq,
    allExchangeCodeConsumeChannelList,
    allProductPurchaseItemList,
    emptyAddOrUpdateExchangeCodeReq,
    emptyExchangeCode,
    ExchangeCode,
    ExchangeCodeColumn,
    ExchangeCodePaginationData,
    getExchangeCodeConsumeChannelDesc,
    getProductPurchaseItemDesc,
    queryExchangeCodeByPage,
    QueryExchangeCodeByPageReq
} from "../../../../data/order/ExchangeCode";
import {queryNewUserStatics, QueryNewUserStaticsReq, UserStaticsData} from "../../../../data/user";
import {ColumnUnit} from "../../../../../library/atomic/unit/ColumnUnit";
import {SizeAttr} from "../../../../../library/basic/size";
import {ColorAttr} from "../../../../../library/basic/color";
import {ColumnAttr, RowAttr} from "../../../../../library/basic/compose";
import {ModifyInputSelect, ModifyInputString, ModifyInputTextArea} from "../ModifyInput";
import {RowUnit} from "../../../../../library/atomic/unit/RowUnit";
import {SpanText} from "../../../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../../../library/basic/font";
import {InputSelect, InputString} from "../FilterInput";
import {heightGap} from "../../../../../library/atomic/unit/BoxUnit";


export class ExchangeCodePanel extends Component {
    static contextType = WindowParamContext;

    state: {
        detail_id: string
        query_request: QueryExchangeCodeByPageReq
        query_data: ExchangeCodePaginationData
        op_request: AddOrUpdateExchangeCodeReq
        user_stats: UserStaticsData
    } = {
        detail_id: "-1",
        query_request: {
            exchange_code: "",
            consume_channel: "",
            product_purchase_item: "",
            remark: "",
            page_num: 1,
            page_size: 10,
        },
        query_data: {
            total: 0,
            list: [],
        },
        op_request: emptyAddOrUpdateExchangeCodeReq,
        user_stats: {
            days: 7,
            stats: []
        }
    }

    queryCertainPage(pageNum: number, pageSize: number) {
        let query_request = Object.assign(this.state.query_request, {
            page_num: pageNum,
            page_size: pageSize,
        });
        queryExchangeCodeByPage(query_request, (success, resp) => {
            if (success && resp) {
                this.setState(prevState => (Object.assign(prevState,
                    {
                        query_request: query_request,
                        query_data: resp.data
                    }
                )))
                // message.open({
                //     type: 'success',
                //     content: "查询成功",
                // });
            }
        })
    }

    handleOperateClose() {
        this.setState(prevState => (Object.assign(prevState, {detail_id: "-1"})))
    }

    handleAddOrUpdateConfirm() {
        if (this.state.op_request.exchange_code.length != 8) {
            message.open({
                type: 'warning',
                content: "兑换码长度不正确",
            });
            return
        }
        if (this.state.op_request.consume_channels.length == 0) {
            message.open({
                type: 'warning',
                content: "生效渠道不能为空",
            });
            return
        }
        if (this.state.op_request.remark.length == 0) {
            message.open({
                type: 'warning',
                content: "备注不能为空",
            });
            return
        }
        if (this.state.op_request.product_purchase_item.length == 0) {
            message.open({
                type: 'warning',
                content: "兑换单品不能为空",
            });
            return
        }
        if (this.state.op_request.product_amount == 0) {
            message.open({
                type: 'warning',
                content: "兑换数量不能为0",
            });
            return
        }
        addOrUpdateExchangeCode(this.state.op_request, (success, resp) => {
            if (success) {
                message.success("新增/更新成功")
                // 关闭对话框
                this.handleOperateClose()
                // 重新查询本页数据
                this.queryCertainPage(this.state.query_request.page_num, this.state.query_request.page_size)
            } else {
                message.error(resp?.msg ? resp?.msg : "操作失败")
            }
        })
    }

    handleAddNewExchangeCode() {
        this.setState(prevState => (Object.assign(prevState, {
            detail_id: "0",
            op_request: {
                exchange_code: "",
                consume_channels: "",
                remark: "",
                product_purchase_item: "",
                product_amount: 1,
                valid: true,
                product_custom_config: { lot_balance: 0, fengling_balance: 0 },
                exchange_success_hint: "",
                exchange_limit: 0,
            }
        })))
    }

    handleExchangeCodeViewDetail(id: string) {
        let e = this.findDetailEntity(id);
        this.setState(prevState => (Object.assign(prevState, {
            detail_id: id,
            op_request: {
                exchange_code: e.exchange_code,
                consume_channels: e.consume_channels,
                remark: e.remark,
                product_purchase_item: e.product_purchase_item,
                product_amount: e.product_amount,
                valid: e.valid,
                product_custom_config: e.product_custom_config,
                exchange_success_hint: e.exchange_success_hint,
                exchange_limit: e.exchange_limit,
            }
        })))
    }

    findDetailEntity(detail_id: string): ExchangeCode {
        for (let i = 0; i < this.state.query_data.list.length; i++) {
            if (this.state.query_data.list[i].id == detail_id) {
                return this.state.query_data.list[i]
            }
        }
        return emptyExchangeCode
    }

    queryUserStats() {
        const req: QueryNewUserStaticsReq = {
            days: 7
        };
        queryNewUserStatics(req, (success, resp) => {
            if (success && resp) {
                this.setState(prevState => (Object.assign(prevState, {
                    user_stats: resp.data
                })));
            }
        });
    }

    componentDidMount() {
        this.queryCertainPage(1, 10)
        this.queryUserStats()
    }

    render() {
        return (
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;

                    return (
                        <ColumnUnit
                            sizeAttr={new SizeAttr(wp, "100vw")}
                            colorAttr={new ColorAttr(wp, "", "#FFFFFF")}
                            customStyleAttr={ColumnAttr.getChildrenPositionObj()}>

                            {/*详情 Dialog*/}
                            <Drawer
                                width={960}
                                title={this.state.detail_id == "0" ? "新增兑换码" : "设置兑换码"}
                                open={this.state.detail_id != "-1"}
                                onClose={() => {
                                    this.handleOperateClose()
                                }}>
                                <ColumnUnit
                                    customStyleAttr={{"padding": "16px"}}
                                    sizeAttr={new SizeAttr(wp, "928px")}>
                                    {ModifyInputString(wp, "兑换码", this.state.op_request.exchange_code,
                                        (v) => {
                                            let op_request = Object.assign(
                                                this.state.op_request, {exchange_code: v})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, "", "660px", "36px", "100px", "22px", "text",
                                        this.state.detail_id != "0"
                                    )}
                                    {ModifyInputSelect(wp, "可用渠道", this.state.op_request.consume_channels,
                                        (v) => {
                                            let op_request = Object.assign(
                                                this.state.op_request, {consume_channels: v})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, allExchangeCodeConsumeChannelList.map((v) => {
                                            return {value: v, label: getExchangeCodeConsumeChannelDesc(v)}
                                        }),
                                        "660px", "36px", "100px", "22px",
                                        this.state.detail_id != "0"
                                    )}
                                    {ModifyInputSelect(wp, "兑换单品", this.state.op_request.product_purchase_item + "",
                                        (v) => {
                                            let op_request = Object.assign(
                                                this.state.op_request, {product_purchase_item: v})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, allProductPurchaseItemList.map((v) => {
                                            return {value: v + "", label: getProductPurchaseItemDesc(v)}
                                        }),
                                        "660px", "36px", "100px", "22px",
                                        this.state.detail_id != "0"
                                    )}
                                    {this.state.op_request.product_purchase_item != "CustomExchangeCode" && ModifyInputString(wp, "兑换的物品数量", this.state.op_request.product_amount.toString(),
                                        (v) => {
                                            let nv = 0
                                            try {
                                                nv = Number(v)
                                            } catch (e) {

                                            }
                                            let op_request = Object.assign(
                                                this.state.op_request, {product_amount: nv})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, "", "660px", "36px", "100px", "22px", "text",
                                        this.state.detail_id != "0"
                                    )}
                                    {this.state.op_request.product_purchase_item == "CustomExchangeCode" && ModifyInputString(wp, "抽签次数", this.state.op_request.product_custom_config.lot_balance.toString(),
                                        (v) => {
                                            let nv = 0
                                            try {
                                                nv = Number(v)
                                            } catch (e) {

                                            }
                                            let product_custom_config = Object.assign(
                                                this.state.op_request.product_custom_config, {lot_balance: nv})
                                            let op_request = Object.assign(
                                                this.state.op_request, {product_custom_config: product_custom_config})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, "", "660px", "36px", "100px", "22px", "text",
                                        false
                                    )}
                                    {this.state.op_request.product_purchase_item == "CustomExchangeCode" && ModifyInputString(wp, "风翎数量", this.state.op_request.product_custom_config.fengling_balance.toString(),
                                        (v) => {
                                            let nv = 0
                                            try {
                                                nv = Number(v)
                                            } catch (e) {

                                            }
                                            let product_custom_config = Object.assign(
                                                this.state.op_request.product_custom_config, {fengling_balance: nv})
                                            let op_request = Object.assign(
                                                this.state.op_request, {product_custom_config: product_custom_config})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, "", "660px", "36px", "100px", "22px", "text",
                                        false
                                    )}
                                    {ModifyInputString(wp, "使用次数限制（0表示没有限制）", this.state.op_request.exchange_limit.toString(),
                                        (v) => {
                                            let nv = 0
                                            try {
                                                nv = Number(v)
                                            } catch (e) {

                                            }
                                            let op_request = Object.assign(
                                                this.state.op_request, {exchange_limit: nv})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, "", "660px", "36px", "100px", "22px", "text",
                                        false
                                    )}
                                    {ModifyInputString(wp, "兑换成功提示", this.state.op_request.exchange_success_hint,
                                        (v) => {
                                            let op_request = Object.assign(
                                                this.state.op_request, {exchange_success_hint: v})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, "", "660px", "36px", "100px", "22px", "text",
                                        false
                                    )}
                                    {ModifyInputTextArea(wp, "备注", this.state.op_request.remark,
                                        (v) => {
                                            let op_request = Object.assign(
                                                this.state.op_request, {remark: v})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, "", "660px", "", "100px", "22px", "text",
                                        false
                                    )}
                                    {ModifyInputSelect(wp, "是否生效", this.state.op_request.valid + "", (v) => {
                                            let op_request = Object.assign(
                                                this.state.op_request, {valid: v == "true"})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {op_request: op_request})))
                                        }, [{value: "true", label: "生效中"}, {value: "false", label: "已失效"}],
                                        "660px", "36px", "100px", "22px", false
                                    )}

                                    <Button
                                        style={{
                                            "marginTop": "36px",
                                            "width": "114px"
                                        }}
                                        onClick={() => {
                                            this.handleAddOrUpdateConfirm();
                                        }}
                                        type={"primary"} >{this.state.detail_id == "0" ? "新增" : "更新"}</Button>
                                </ColumnUnit>
                            </Drawer>

                            {/*数据板块*/}
                            <ColumnUnit
                                sizeAttr={new SizeAttr(wp, SizeAttr.pxMinus(SizeAttr.changeVwToPx(wp, "100vw"), "32px"))}
                                customStyleAttr={{"padding": "16px"}}
                            >
                                {/*用户统计信息*/}
                                <ColumnUnit customStyleAttr={{"marginBottom": "24px", "padding": "16px", "backgroundColor": "#f5f5f5", "borderRadius": "8px"}}>
                                    <RowUnit customStyleAttr={{"marginBottom": "12px"}}>
                                        <SpanText
                                            colorAttr={new ColorAttr(wp, "#333333")}
                                            customStyleAttr={{}}
                                            fontAttr={new FontAttr(wp, "1.2em", "600")}>
                                            {"最近七天新增用户统计"}
                                        </SpanText>
                                    </RowUnit>
                                    <RowUnit customStyleAttr={{"flexWrap": "wrap", "gap": "12px"}}>
                                        {this.state.user_stats.stats.map((count, index) => {
                                            const date = new Date();
                                            date.setDate(date.getDate() - (6 - index));
                                            const dateStr = date.toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit' });
                                            
                                            return (
                                                <RowUnit key={index} customStyleAttr={{
                                                    "padding": "8px 12px",
                                                    "backgroundColor": "#FFFFFF",
                                                    "borderRadius": "6px",
                                                    "border": "1px solid #E8E8E8",
                                                    "minWidth": "80px",
                                                    "justifyContent": "center"
                                                }}>
                                                    <ColumnUnit customStyleAttr={{"alignItems": "center"}}>
                                                        <SpanText
                                                            colorAttr={new ColorAttr(wp, "#666666")}
                                                            customStyleAttr={{}}
                                                            fontAttr={new FontAttr(wp, "0.8em", "400")}>
                                                            {dateStr}
                                                        </SpanText>
                                                        <SpanText
                                                            colorAttr={new ColorAttr(wp, "#1777FF")}
                                                            customStyleAttr={{}}
                                                            fontAttr={new FontAttr(wp, "1.1em", "600")}>
                                                            {count.toString()}
                                                        </SpanText>
                                                        <SpanText
                                                            colorAttr={new ColorAttr(wp, "#999999")}
                                                            customStyleAttr={{}}
                                                            fontAttr={new FontAttr(wp, "0.7em", "400")}>
                                                            {"人"}
                                                        </SpanText>
                                                    </ColumnUnit>
                                                </RowUnit>
                                            );
                                        })}
                                    </RowUnit>
                                    <RowUnit customStyleAttr={{"marginTop": "12px", "paddingTop": "12px", "borderTop": "1px solid #E8E8E8"}}>
                                        <SpanText
                                            colorAttr={new ColorAttr(wp, "#333333")}
                                            customStyleAttr={{"marginRight": "8px"}}
                                            fontAttr={new FontAttr(wp, "1em", "500")}>
                                            {"总计："}
                                        </SpanText>
                                        <SpanText
                                            colorAttr={new ColorAttr(wp, "#1777FF")}
                                            customStyleAttr={{}}
                                            fontAttr={new FontAttr(wp, "1em", "600")}>
                                            {this.state.user_stats.stats.reduce((sum, count) => sum + count, 0).toString()}
                                        </SpanText>
                                        <SpanText
                                            colorAttr={new ColorAttr(wp, "#666666")}
                                            customStyleAttr={{"marginLeft": "4px"}}
                                            fontAttr={new FontAttr(wp, "0.9em", "400")}>
                                            {"人"}
                                        </SpanText>
                                    </RowUnit>
                                </ColumnUnit>

                                <RowUnit customStyleAttr={{"marginBottom": "16px"}}>
                                    <SpanText
                                        colorAttr={new ColorAttr(wp, "#1777FF")}
                                        customStyleAttr={{"justifyContent": ""}}
                                        fontAttr={new FontAttr(wp, "1.4em", "600")}>
                                        {"兑换码"}
                                    </SpanText>
                                </RowUnit>

                                {/*过滤字段*/}
                                <RowUnit>
                                    {InputString(wp, "兑换码", this.state.query_request.exchange_code.toString(),
                                        (v) => {
                                            try {
                                                let query_request = Object.assign(
                                                    this.state.query_request, {exchange_code: v})
                                                this.setState(prevState => (Object.assign(
                                                    prevState, {query_request: query_request})))
                                            } catch (e) {
                                                console.log(e)
                                            }
                                        }
                                    )}
                                    {InputSelect(wp, "可用渠道", this.state.query_request.consume_channel,
                                        (v) => {
                                            let query_request = Object.assign(
                                                this.state.query_request, {consume_channel: v})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {query_request: query_request})))
                                        },
                                        [...[{value: "", label: "不限"}],
                                            ...(allExchangeCodeConsumeChannelList.map((v) => {
                                                return {value: v, label: getExchangeCodeConsumeChannelDesc(v)}
                                            }))]
                                        , "180px"
                                    )}
                                    {InputSelect(wp, "兑换单品", this.state.query_request.product_purchase_item,
                                        (v) => {
                                            let query_request = Object.assign(
                                                this.state.query_request, {product_purchase_item: v})
                                            this.setState(prevState => (Object.assign(
                                                prevState, {query_request: query_request})))
                                        },
                                        [...[{value: "", label: "不限"}],
                                            ...(allProductPurchaseItemList.map((v) => {
                                                return {value: v + "", label: getProductPurchaseItemDesc(v)}
                                            }))]
                                        , "240px"
                                    )}
                                    {InputString(wp, "备注", this.state.query_request.remark,
                                        (v) => {
                                            try {
                                                let query_request = Object.assign(
                                                    this.state.query_request, {remark: v})
                                                this.setState(prevState => (Object.assign(
                                                    prevState, {query_request: query_request})))
                                            } catch (e) {
                                                console.log(e)
                                            }
                                        }
                                    )}

                                    <Button
                                        style={Object.assign(RowAttr.getChildrenPositionObj(), {
                                            "marginLeft": "auto"
                                        })}
                                        icon={<SearchOutlined/>}
                                        type={"primary"}
                                        onClick={() => {
                                            this.handleAddNewExchangeCode();
                                        }}
                                    >
                                        {"新增"}
                                    </Button>

                                    <Button
                                        style={Object.assign(RowAttr.getChildrenPositionObj(), {
                                            "marginLeft": "16px"
                                        })}
                                        icon={<SearchOutlined/>}
                                        type={"primary"}
                                        onClick={() => {
                                            this.queryCertainPage(1,
                                                this.state.query_request.page_size)
                                            let qr = this.state.query_request
                                            qr.page_num = 1
                                            this.setState(prevState => (Object.assign(prevState, {query_request: qr})))
                                        }}
                                    >
                                        {"查询"}
                                    </Button>
                                </RowUnit>

                                {heightGap(wp, "16px")}
                                <Table
                                    style={{
                                        "width": SizeAttr.pxMinus(SizeAttr.changeVwToPx(wp, "100vw"), "32px")
                                    }}
                                    pagination={{
                                        current: this.state.query_request.page_num,
                                        onChange: (page, pageSize) => {
                                            this.queryCertainPage(page, pageSize)
                                        },
                                        total: this.state.query_data.total,
                                    }}
                                    bordered={true}
                                    columns={ExchangeCodeColumn((id: string) => {
                                        this.handleExchangeCodeViewDetail(id)
                                    })}
                                    dataSource={this.state.query_data.list}
                                />
                            </ColumnUnit>
                        </ColumnUnit>
                    )
                }
                }
            </WindowParamContext.Consumer>
        )
    }
}